import { account } from '../core/account.js';
import { i18n, t } from '../core/i18n.js';
import { notify } from '../core/notify.js';
import { escapeHtml, formatDate } from '../core/utils.js';

/* Panel de denuncias (solo administradores): lista por estado, detalle y decisiones. Habla con
   /api/reports/admin/* (server/reports.js); es lo mismo que scripts/reports.js pero desde la aplicación. */

const FILTERS = ['new', 'reviewing', 'hidden', 'removed', 'rejected', 'closed', ''];
const ERR = ['nothing_to_hide', 'empty'];

export function openReportsAdmin() {
    const app = window.app;
    const id = 'repadm-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${t('reports.admin.title')}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content"><div class="phone-body" data-adm></div></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const body = (p.el || document.getElementById(id)).querySelector('[data-adm]');
                let filter = 'new';
                let counts = {};

                const when = (ms) => formatDate(ms, i18n.lang);
                const call = (method, path, data) => account.request(method, path, data ? { body: data } : {});

                const listScreen = async () => {
                    body.innerHTML = '<div class="spinner"></div>';
                    let data;
                    try { data = await call('GET', '/api/reports/admin/list' + (filter ? '?status=' + filter : '')); } catch (e) { body.innerHTML = `<div class="phone-status is-error">${t('common.errorNetwork')}</div>`; return; }
                    counts = data.counts || {};
                    const total = Object.keys(counts).reduce((n, k) => n + counts[k], 0);
                    const chips = FILTERS.map((f) => `<button type="button" class="chip ${f === filter ? 'is-active' : ''}" data-filter="${f}">${t('reports.admin.filter.' + (f || 'all'))}${(f ? counts[f] : total) ? ` <b>${f ? counts[f] : total}</b>` : ''}</button>`).join('');
                    body.innerHTML = `<div class="chips" data-nav-row>${chips}</div>
                        ${data.reports.length ? data.reports.map((r) => `<button type="button" class="admin-user ${r.hidden ? '' : ''}" data-report="${r.id}" style="width:100%;text-align:left">
                            <span class="admin-avatar mi">${r.hidden ? 'visibility_off' : 'flag'}</span>
                            <div class="admin-user-body">
                                <div class="admin-user-name">${escapeHtml(r.ref)} <span class="tag">${t('report.kind.' + r.kind)}</span> <span class="tag ${r.status === 'new' ? '' : 'tag-off'}">${t('reports.admin.filter.' + r.status)}</span></div>
                                <div class="admin-user-sub">${escapeHtml(r.label)} · ${escapeHtml(r.reporter)} · ${escapeHtml(when(r.createdAt))}</div>
                            </div>
                        </button>`).join('') : `<p class="pw-note">${t('reports.admin.empty')}</p>`}`;
                };

                const row = (label, value) => (value ? `<div class="admin-user-sub"><b>${escapeHtml(label)}:</b> ${escapeHtml(value)}</div>` : '');

                const detailScreen = async (reportId) => {
                    body.innerHTML = '<div class="spinner"></div>';
                    let r;
                    try { r = (await call('GET', '/api/reports/admin/get?id=' + encodeURIComponent(reportId))).report; } catch (e) { body.innerHTML = `<div class="phone-status is-error">${t('common.errorNetwork')}</div>`; return; }
                    const acts = [['review', 'rate_review'], ['hide', 'visibility_off'], ['retire', 'delete'], ['reject', 'undo'], ['reply', 'reply'], ['close', 'check']];
                    body.innerHTML = `<button type="button" class="btn" data-back><span class="mi">arrow_back</span>${t('common.back')}</button>
                        <h3>${escapeHtml(r.ref)} <span class="tag">${t('report.kind.' + r.kind)}</span> <span class="tag tag-off">${t('reports.admin.filter.' + r.status)}</span>${r.hidden ? ` <span class="tag">${t('reports.admin.hidden')}</span>` : ''}</h3>
                        ${row(t('reports.admin.about'), r.label + (r.targetId ? ' [' + r.targetId + ']' : ''))}
                        ${row(t('reports.admin.from'), `${r.reporterName || '—'} <${r.reporterEmail}> (${r.reporterRole})`)}
                        ${row(t('report.rightsOwner'), r.rightsOwner)}
                        ${r.kind === 'copyright' ? row(t('reports.admin.goodFaith'), r.goodFaith ? '✓' : '✗') + row(t('report.signature'), r.signature) : ''}
                        ${row(t('reports.admin.date'), when(r.createdAt) + ' · ' + r.origin + ' · ' + r.lang)}
                        <div class="phone-status" style="white-space:pre-wrap">${escapeHtml(r.description)}</div>
                        ${r.note ? `<div class="admin-user-sub"><b>${t('reports.admin.note')}:</b> ${escapeHtml(r.note)}</div>` : ''}
                        <div class="admin-actions">${acts.map(([a, icon]) => `<button type="button" class="btn btn-block" data-act="${a}"><span class="mi">${icon}</span>${t('reports.admin.act.' + a)}</button>`).join('')}</div>
                        ${r.events.length ? `<h4>${t('reports.admin.history')}</h4>${r.events.map((e) => `<div class="admin-user-sub">${escapeHtml(when(e.at))} · ${escapeHtml(e.action)}${e.text ? ': ' + escapeHtml(e.text) : ''}</div>`).join('')}` : ''}`;
                    body.onclick = (e) => {
                        if (e.target.closest('[data-back]')) return listScreen();
                        const b = e.target.closest('[data-act]');
                        if (!b) return;
                        const act = b.getAttribute('data-act');
                        const send = async (text) => {
                            try {
                                const out = await call('POST', '/api/reports/admin/decide', { id: r.id, action: act, text: text || '' });
                                notify.toast(t('reports.admin.done') + (['retire', 'reject', 'reply', 'close'].indexOf(act) !== -1 ? (out.emailed ? ' · ' + t('reports.admin.emailed') : (act === 'close' && !text ? '' : ' · ' + t('reports.admin.notEmailed'))) : ''), { icon: 'check', duration: 2500 });
                                detailScreen(r.id);
                            } catch (err) {
                                notify.error(ERR.indexOf(err.code) !== -1 ? t('reports.admin.err.' + err.code) : t('common.errorNetwork'));
                            }
                        };
                        if (act === 'retire' || act === 'reject' || act === 'reply' || act === 'close') {
                            app.dialog.prompt(t(act === 'reply' ? 'reports.admin.text.reply' : 'reports.admin.text.optional'), t('reports.admin.act.' + act), (value) => send(String(value || '').trim()), null, '');
                        } else send('');
                    };
                };

                body.onclick = (e) => {
                    const f = e.target.closest('[data-filter]');
                    if (f) { filter = f.getAttribute('data-filter'); return listScreen(); }
                    const r = e.target.closest('[data-report]');
                    if (r) detailScreen(r.getAttribute('data-report'));
                };
                listScreen();
            },
            closed() {
                try { popup.destroy(); } catch (e) { /* ya destruido */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
